const initCarbonHeader = () => {
  //menu drawer open / close
  const menu = document.querySelector('.menu-drawer-container');
  if (!menu) return;
  const summaryElement = menu.querySelector('summary');
  const navBarContainer = document.querySelector('.navigation-bar-container');

  const toggleHeaderElements = (element) => {
    menu.classList.toggle('menu-opening');
    menu.setAttribute('open', '');
    element.setAttribute('aria-expanded', true);
    summaryElement.setAttribute('aria-expanded', true);
    document.body.classList.add('overflow-hidden-tablet');
    summaryElement.focus();
    navBarContainer ? navBarContainer.style.display = 'flex' : null;
  }
  
  //quick-links from header to open drawer
  const quickLinksButtons = document.querySelectorAll('.header-drawer-quick-links-container button');
  quickLinksButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetClass = button.dataset.targetClass;
      const icon = menu.querySelector('.header__icon--menu');
      toggleHeaderElements(icon);
  
      const drawers = document.querySelectorAll(`.${targetClass}`);
      drawers.forEach((drawer) => {
        drawer.setAttribute('aria-expanded', true);
        drawer.parentNode.setAttribute('open', true);
        drawer.parentNode.classList.toggle('menu-opening');
      });
    });
  });

  const openSearchButton = document.querySelector('[data-open-search-mobile]');
  openSearchButton.addEventListener('click', () => {
    toggleHeaderElements(summaryElement);
    const searchInput = menu.querySelector('.search-input');
    if (searchInput) {
      searchInput.focus();
    }
  });
  
  const openDrawer = document.querySelector('[data-open-menu-drawer-mobile]');
  openDrawer.addEventListener('click', () => {
    if (window.innerWidth < 1150 || window.innerHeight < 575) {
      toggleHeaderElements(summaryElement);
    }
  }); 
}
initCarbonHeader();
